<template>
  <!-- options 自定义删除停用状态 -->
  <div>
    <span style="float: left; margin-right: 14px">{{ dict.name }}</span>
    <span v-if="dict.status_delete !== '1' || dict.status_active !== '1'" style="float: right; color: #8492a6; font-size: 12px">
      <template v-if="dict.status_delete && (dict.status_delete !== '1')">已删除</template>
      <template v-else>
        {{ dict.status_active !== '1' ? '已停用' : ''}}
      </template>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    dict: {
      type: Object,
      default: null
    }
  },
}
</script>

<style lang="less">
</style>